export default __webpack_public_path__ + "static/media/scatter-plot.2267ebf2.svg";